<script>
    let notice = "";

    async function getNotice() {
        const url = `https://www.1hg.org/programme_addition_scouts`;
        const response = await fetch(`https://api.allorigins.win/raw?url=${encodeURIComponent(`${url}?t=${new Date().getTime()}`)}`);
        const data = await response.text();
        return data;
    }
    getNotice().then( data => {
        notice = data;
    });

</script>
<div class="wrapper">
    <div class="notice">
        {@html notice}
    </div>
    <p class="clear">
        <span class="bold">Notice to Parents/Guardians</span><br/>
        Online Scout Manager is how we communicate by default. Please make sure to check
        your e-mail for details of nights and events where locations and times deviate
        from the standard. If you miss an email, or think you may have, check OSM, where
        you can see an archive of recent emails sent.
    </p>

    <p class="extra_notice">
        Missed a week and not sure what's happening?<br/>
        Check with one of the leaders below or email scouts@1hg.org
    </p>

    <table class="leaders">
        <tr>
            <td>SL</td><td>Rob Ogilvie - 07971 929 150</td>
            <td class="right">DSL</td><td>Matt Geeling - 07872 475 448</td>
        </tr>
        <tr>
            <td>ASL</td><td>Phil Horne - 07834 783 154</td>
            <td class="right">ASL</td><td>John Corbett - 07889 307 172</td>
        </tr>
        <tr>
            <td>ASL</td><td>Luke Warwick</td>
            <td class="right">CSL</td><td>Nic Sykes</td>
        </tr>
    </table>
</div>

<style>
    div.socials {
        text-align: center;
        width: 600px;
        margin: auto;
        min-height: 200px;
    }
    div.notice {
        text-align: center;
        width: 600px;
        margin: 0 auto;
        background: #006ddf;
        color: #fff;
        border: 1px solid #003982;
        -webkit-print-color-adjust: exact;
    }
    .clear {
        clear: both;
    }
    div.socials > div {
        float: left;
    }
    .fa {
            padding: 20px;
            font-size: 130px;
            width: 140px;
            text-decoration: none;
            /* margin: 5px 80px; */
    }
    div.wrapper {
        width: 90%;
        margin: 0 auto;
        padding-top: 100px;
    }
    span.bold {
        font-weight: bold;
    }
    p.extra_notice {
        text-align: center;
        color: #33f;
    }
    td.right {
        padding-left: 40px;
    }
</style>